var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrendlines = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.7067 2.35352L21.1903 3.22882L2.48366 13.5634L2.00009 12.6881L20.7067 2.35352ZM15.0779 6.66331L17.2928 8.27857L13.5927 12.7991L9.72399 9.97769L4.10678 16.85L5.24503 17.6801L2 18.4222L2.22291 19.397L21.56 14.9752L21.3371 14.0004L5.68801 17.5788L10.0197 12.2865L13.8884 15.108L18.6662 9.28018L20.881 10.8954L20.2541 6.00036L15.0779 6.66331Z",
  fill: "#7F7F7F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrendlines);
export { ForwardRef as ReactComponent };